/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  Label,
  LabelGroup,
  LabelGroupWithLabels,
  LabelWithLabelGroup,
} from "../models/index";
import {
  LabelFromJSON,
  LabelToJSON,
  LabelGroupFromJSON,
  LabelGroupToJSON,
  LabelGroupWithLabelsFromJSON,
  LabelGroupWithLabelsToJSON,
  LabelWithLabelGroupFromJSON,
  LabelWithLabelGroupToJSON,
} from "../models/index";

export interface CreateLabelRequest {
  label: Label;
}

export interface CreateLabelGroupRequest {
  labelGroup: LabelGroup;
}

export interface DeleteLabelRequest {
  labelId: string;
}

export interface DeleteLabelGroupRequest {
  labelGroupId: string;
}

export interface GetCompaniesByLabelsRequest {
  labelsIds: Array<string>;
}

export interface GetCompanyLabelsRequest {
  companyId: string;
}

export interface GetCompanyLabelsWithLabelGroupRequest {
  companyId: string;
}

export interface GetLabelGroupByIdRequest {
  labelGroupId: string;
}

export interface GetLabelGroupWithLabelsByIdRequest {
  labelGroupId: string;
}

export interface GetLabelsByCompanyIdsRequest {
  companiesIds: Array<string>;
}

export interface UpdateLabelRequest {
  label: Label;
}

export interface UpdateLabelGroupRequest {
  labelGroup: LabelGroup;
}

/**
 *
 */
export class CompanyLabelsApi extends runtime.BaseAPI {
  /**
   */
  async createLabelRaw(
    requestParameters: CreateLabelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["label"] == null) {
      throw new runtime.RequiredError(
        "label",
        'Required parameter "label" was null or undefined when calling createLabel().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-labels/create-label`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LabelToJSON(requestParameters["label"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createLabel(
    requestParameters: CreateLabelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createLabelRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createLabelGroupRaw(
    requestParameters: CreateLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["labelGroup"] == null) {
      throw new runtime.RequiredError(
        "labelGroup",
        'Required parameter "labelGroup" was null or undefined when calling createLabelGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-labels/create-label-group`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LabelGroupToJSON(requestParameters["labelGroup"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createLabelGroup(
    requestParameters: CreateLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createLabelGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteLabelRaw(
    requestParameters: DeleteLabelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters["labelId"] == null) {
      throw new runtime.RequiredError(
        "labelId",
        'Required parameter "labelId" was null or undefined when calling deleteLabel().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["labelId"] != null) {
      queryParameters["labelId"] = requestParameters["labelId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/delete-label`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteLabel(
    requestParameters: DeleteLabelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<boolean> {
    const response = await this.deleteLabelRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteLabelGroupRaw(
    requestParameters: DeleteLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters["labelGroupId"] == null) {
      throw new runtime.RequiredError(
        "labelGroupId",
        'Required parameter "labelGroupId" was null or undefined when calling deleteLabelGroup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["labelGroupId"] != null) {
      queryParameters["labelGroupId"] = requestParameters["labelGroupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/delete-label-group`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteLabelGroup(
    requestParameters: DeleteLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<boolean> {
    const response = await this.deleteLabelGroupRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getAllLabelGroupsWithLabelsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<LabelGroupWithLabels>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-all-label-groups-with-labels`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LabelGroupWithLabelsFromJSON),
    );
  }

  /**
   */
  async getAllLabelGroupsWithLabels(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<LabelGroupWithLabels>> {
    const response = await this.getAllLabelGroupsWithLabelsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getAllLabelsGroupRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<LabelGroup>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-all-labels-group`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LabelGroupFromJSON),
    );
  }

  /**
   */
  async getAllLabelsGroup(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<LabelGroup>> {
    const response = await this.getAllLabelsGroupRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getCompaniesByLabelsRaw(
    requestParameters: GetCompaniesByLabelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<string>>> {
    if (requestParameters["labelsIds"] == null) {
      throw new runtime.RequiredError(
        "labelsIds",
        'Required parameter "labelsIds" was null or undefined when calling getCompaniesByLabels().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["labelsIds"] != null) {
      queryParameters["labelsIds"] = requestParameters["labelsIds"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-companies-by-labels`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async getCompaniesByLabels(
    requestParameters: GetCompaniesByLabelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<string>> {
    const response = await this.getCompaniesByLabelsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyLabelsRaw(
    requestParameters: GetCompanyLabelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Label>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyLabels().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-company-labels`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LabelFromJSON),
    );
  }

  /**
   */
  async getCompanyLabels(
    requestParameters: GetCompanyLabelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Label>> {
    const response = await this.getCompanyLabelsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyLabelsWithLabelGroupRaw(
    requestParameters: GetCompanyLabelsWithLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<LabelWithLabelGroup>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyLabelsWithLabelGroup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-company-labels-with-label-group`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LabelWithLabelGroupFromJSON),
    );
  }

  /**
   */
  async getCompanyLabelsWithLabelGroup(
    requestParameters: GetCompanyLabelsWithLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<LabelWithLabelGroup>> {
    const response = await this.getCompanyLabelsWithLabelGroupRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getLabelGroupByIdRaw(
    requestParameters: GetLabelGroupByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LabelGroup>> {
    if (requestParameters["labelGroupId"] == null) {
      throw new runtime.RequiredError(
        "labelGroupId",
        'Required parameter "labelGroupId" was null or undefined when calling getLabelGroupById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["labelGroupId"] != null) {
      queryParameters["labelGroupId"] = requestParameters["labelGroupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/Get-label-group-by-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LabelGroupFromJSON(jsonValue),
    );
  }

  /**
   */
  async getLabelGroupById(
    requestParameters: GetLabelGroupByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LabelGroup> {
    const response = await this.getLabelGroupByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getLabelGroupWithLabelsByIdRaw(
    requestParameters: GetLabelGroupWithLabelsByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LabelGroupWithLabels>> {
    if (requestParameters["labelGroupId"] == null) {
      throw new runtime.RequiredError(
        "labelGroupId",
        'Required parameter "labelGroupId" was null or undefined when calling getLabelGroupWithLabelsById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["labelGroupId"] != null) {
      queryParameters["labelGroupId"] = requestParameters["labelGroupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-label-group-with-labels`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LabelGroupWithLabelsFromJSON(jsonValue),
    );
  }

  /**
   */
  async getLabelGroupWithLabelsById(
    requestParameters: GetLabelGroupWithLabelsByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LabelGroupWithLabels> {
    const response = await this.getLabelGroupWithLabelsByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getLabelsByCompanyIdsRaw(
    requestParameters: GetLabelsByCompanyIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<
    runtime.ApiResponse<{ [key: string]: Array<LabelWithLabelGroup> }>
  > {
    if (requestParameters["companiesIds"] == null) {
      throw new runtime.RequiredError(
        "companiesIds",
        'Required parameter "companiesIds" was null or undefined when calling getLabelsByCompanyIds().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companiesIds"] != null) {
      queryParameters["companiesIds"] = requestParameters["companiesIds"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-labels/get-labels-by-company-ids`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async getLabelsByCompanyIds(
    requestParameters: GetLabelsByCompanyIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: Array<LabelWithLabelGroup> }> {
    const response = await this.getLabelsByCompanyIdsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateLabelRaw(
    requestParameters: UpdateLabelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["label"] == null) {
      throw new runtime.RequiredError(
        "label",
        'Required parameter "label" was null or undefined when calling updateLabel().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-labels/update-label`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: LabelToJSON(requestParameters["label"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateLabel(
    requestParameters: UpdateLabelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateLabelRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateLabelGroupRaw(
    requestParameters: UpdateLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["labelGroup"] == null) {
      throw new runtime.RequiredError(
        "labelGroup",
        'Required parameter "labelGroup" was null or undefined when calling updateLabelGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-labels/update-label-group`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: LabelGroupToJSON(requestParameters["labelGroup"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateLabelGroup(
    requestParameters: UpdateLabelGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateLabelGroupRaw(requestParameters, initOverrides);
  }
}
